import {Action} from "@ngrx/store";

export const LOAD_TEN_WEB_PRODUCTS: string = '[tenWebProduct] Load Ten Web Products';
export const LOAD_TEN_WEB_PRODUCTS_SUCCESS: string = '[tenWebProduct] Load Ten Web Products Success';
export const LOAD_TEN_WEB_PRODUCTS_FAIL: string = '[tenWebProduct] Load Ten Web Products Fail';

export class LoadTenWebProducts implements Action {

  readonly type: string = LOAD_TEN_WEB_PRODUCTS;

}

export class LoadTenWebProductsSuccess implements Action {

  readonly type: string = LOAD_TEN_WEB_PRODUCTS_SUCCESS;
  constructor(public payload: {
    [slug: string]: any
  }) {}

}

export class LoadTenWebProductsFail implements Action {

  readonly type: string = LOAD_TEN_WEB_PRODUCTS_FAIL;
  constructor(public payload: string) {}

}

export type TenWebProductAction = LoadTenWebProducts | LoadTenWebProductsSuccess | LoadTenWebProductsFail;
